import { AddPolicy } from "components/add-policy";
import { usePoliciesList } from "data/ss-data-hooks";
import SettingsPanelLayout from "pages/settings/common/settings-panel-layout";

import PolicyItem from "./policy-item";

export const Policies = () => {
  const { data } = usePoliciesList();
  const hasMultiplePolicies = data?.length != null && data?.length > 1;

  const policyItems = data?.map((p) => {
    const policy = {
      ...p,
      policyId: p.platformPolicyId,
      insightPolicyId: p.keystonePolicyId,
    };
    return (
      <PolicyItem
        key={policy.policyId}
        policy={policy}
        hasMultiplePolicies={hasMultiplePolicies}
      />
    );
  });

  return (
    <SettingsPanelLayout
      title={
        <>
          Policies <AddPolicy />
        </>
      }
      policyItems={policyItems}
    />
  );
};
